import { FC, memo, useEffect, useMemo } from 'react'
import { PaidServiceStageIds } from '../../../common/types/paidService'
import { Kanban } from '../../../components/Kanban/Kanban'
import { COLORS } from '../lib/colors'
import { KanbanCard } from './KanbanCard'
import { $paidServicesForKanban, getPaidServicesForKanbanFx } from '../../../Api/PaidService/getPaidServicesForKanban'
import { useStore } from 'effector-react'
import { Loader } from '../../../components/UI/Loaders/Loader'
import { Box, Typography } from '@mui/material'
import { $paidServiceFastFilter } from '../../PaidServiceFastFilter/store/paidServiceFastFilter'




export const KanbanOfPaidServices = memo(() => {
  const paidServicesForKanban = useStore($paidServicesForKanban)
  const paidServiceFastFilter = useStore($paidServiceFastFilter)
  const getPaidServicesForKanbanFxIsLoading = useStore(getPaidServicesForKanbanFx.pending)

  useEffect(() => {
    getPaidServicesForKanbanFx({
      myInWork: paidServiceFastFilter?.myInWork ?? undefined,
      myInWorkUnread: paidServiceFastFilter?.myInWorkUnread ?? undefined
    })
  }, [paidServiceFastFilter])

  const cardContentRenderProp = useMemo(() => {
    return ({ item }: any) => <KanbanCard item={item} />
  }, [])

  if (getPaidServicesForKanbanFxIsLoading) {
    return <Loader heightValue={150}/>
  }

  if (!paidServicesForKanban?.length) {
    return (
      <Box height={200} textAlign={'center'}>
        <Typography variant="h3">Нет данных</Typography>
      </Box>
    )
  }

    return (
      <Kanban
        columns={paidServicesForKanban}
        colors={COLORS}
        cardContentRenderProp={cardContentRenderProp}
      />
    )
}
)
